import turflineToPolygon from "@turf/line-to-polygon";

export default function lineToPolygon(feature, options = {}) {
    return turflineToPolygon(feature, options);
}
